<template>
  <div id="app" style="max-width: 1024px;margin:0 auto;background-color: #f4f4f4">
    <keep-alive :include="cached">
      <router-view  :key="key" v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.title" @popShow="popShow"></router-view>
    </keep-alive>
    <router-view  :key="key" v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title" @popShow="popShow"></router-view>
    <Footer v-if="showFooter" style="overflow: hidden"></Footer>
    <van-popup v-model="showpopup" class="popupBox">
      <h3> 数据说明</h3>
      <van-divider />
      <p>统计数据为更新日期处于各状态的受理号、品种、企业的数量。</p>
    </van-popup>
  </div>
</template>

<script>
  import $ from 'jquery'
  import Footer from '@/components/Footer/index.vue'
  export default {
    name: 'App',
    components:{Footer},
    data(){
      return{
        docmHeight: document.documentElement.clientHeight,  //默认屏幕高度
        showHeight: document.documentElement.clientHeight,   //实时屏幕高度
        hideshow:true,  //显示或者隐藏footer
        showFooter:true,
        showpopup:false,
        cached:this.$store.state.catchArr
      }

    },
    computed:{
      key(){
        return this.$route.path
      }
    },
    created(){
      // if(window.location.href.indexOf('home')>-1){
      //   document.title = '仿制药-数据总览'
      // }else if(window.location.href.indexOf('searchQuery')>-1){
      //   document.title = '仿制药-检索查询'
      // }else if(window.location.href.indexOf('firstPass')>-1){
      //   document.title = '仿制药-三年首过'
      // }else if(window.location.href.indexOf('policy')>-1){
      //   document.title = '仿制药-新闻政策'
      // }else {
      //   document.title = '仿制药-数据总览'
      // }
      let u = navigator.userAgent;
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        if((screen.width==375 && screen.height==812)  || (screen.width==414 && screen.height==896)|| (screen.width==390 && screen.height==844)|| (screen.width==428 && screen.height==926)|| (screen.width==360 && screen.height==780)){
          sessionStorage.setItem("isipx","1");
        }else{
          //不是iphoneX
          sessionStorage.setItem("isipx","0");
        }
      }
    },

    watch:{
      showHeight: function () {
        if (this.docmHeight > this.showHeight) {
          this.hideshow = false
        } else {
          this.hideshow = true
        }
      },

      $route(to,from){
        this.cached = this.$store.state.catchArr;
        var ua = navigator.userAgent.toLowerCase();

        if (navigator.userAgent.toLowerCase().indexOf('micromessenger') == -1) {

          // this.$router.push({name:'promptPag'})
          // this.showFooter=false
        }else{
          if(this.$route.name=='promptPag'){
            this.$router.push({name:'home'})
          }
          this.showFooter=true
        }
        if(to.name=="preparationDetail" ||to.name=="medicinalDetail" ||to.name=="baseDetail" ||to.name=="insuranceDetail" ||to.name=="evaluation" ||to.name=="preparation"||to.name=="base"||to.name=="medicinal"||to.name=="insurance" || to.name=="searchQuery" || this.$route.name=='daily' || this.$route.name=='weeks'|| this.$route.name=='drugSearch'|| this.$route.name=='companySearch'||this.$route.name=='preparationsDetail' ){
          this.showFooter=false;
        }else{
          this.showFooter=true;
        }
      }
    },
    mounted() {
      var initialWidth = document.documentElement.clientWidth; //获取当前页面高度
      let self=this
      let footer=$('.footerBox').find(".van-tabbar--fixed")
      var winHeight = $(window).height();  //获取当前页面高度
      $(window).resize(function () {
          var thisHeight = $(this).height();
          var winWidth = document.documentElement.clientWidth //获取当前页面宽度
          if ( winHeight - thisHeight > 140 ) { //键盘弹出
            if(initialWidth<winWidth){
              footer.css({'position':'fixed','bottom':'0'});
            }else{
              footer.css({'position':'fixed','bottom':'-1rem'});
            }
          } else {
            //键盘收起
            footer.css({'position':'fixed','bottom':'0'});
          }
        })
    },
    methods:{
      pushHistory() {
     //写入空白历史路径
        let state = {
          title: 'title',
          url: "#"
        }
        window.history.pushState(state, state.title, state.url)
      },
      popShow(){
      this.showpopup=true
    }
    }
  }
</script>
<style>
html,body,#app{
  height: 100%;
}
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  .popupBox{
    width:60%;
    max-width:400px;
    padding:10px;
    border-radius: 10px;
    font-size: 14px;
  }
  .popupBox .van-divider{
    margin:.24rem 0 .2rem!important;
  }
  .popupBox h3{
    text-align: center!important;
    font-size: .32rem;
    color:#333
  }
  .popupBox p{
    line-height: 24px!important;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue